import { Map } from "immutable";

export function clearToken() {
  localStorage.removeItem("token");
}

export function getToken() {
  try {
    const token = localStorage.getItem("token");
    return new Map({ token });
  } catch (err) {
    clearToken();
    return new Map();
  }
}

export const search = (input, search_string, param) => {
  // let regex = /\s-/g;
  let regex = /\W/g;
  let query = search_string.replace(regex, "").toLowerCase();

  input = input.filter((u) => {
    return u[param]
      .replace(regex, "")
      .toLowerCase()
      .includes(query);
  });
  return input;
};

export const search_2param = (input, search_string, param, subparam) => {
  let regex = /\s-/g;
  let query = search_string.replace(regex, "").toLowerCase();

  input = input.filter((u) => {
    return u[param][subparam]
      .replace(regex, "")
      .toLowerCase()
      .includes(query);
  });
  return input;
};

export const search_manytomany = (input, search_string, param, subparam) => {
  let regex = /\s-/g;
  let query = search_string.toLowerCase();
  input = input.filter((u) => {
    return u[param].find(
      (s) => s[subparam].toLowerCase() === query
      // .replace(regex, "")
      // .toLowerCase()
      // .includes(query)
    );
  });
  return input;
};

export const convertIdentifier = (identifier_index) => {
  if (parseInt(identifier_index) >= 0) {
    let alpha_array = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    return alpha_array[parseInt(identifier_index)];
  } else return identifier_index;
};
